//Dependecies
import React from 'react'
import { useState, useEffect } from 'react';

//Helper functions
import { checkUserIsAdmin } from '../../../global_components/helper_functions/checkUserIsAdmin';
import { fetchCoursesAttendedNumber } from '../../../global_components/helper_functions/fetchCoursesAttendedNumber';
import { fetchUpcomingCoursesNumber } from '../../../global_components/helper_functions/fetchUpcomingCoursesNumber';
import { fetchTotalCoursesNumber } from '../../../global_components/helper_functions/fetchTotalCoursesNumber';
import { fetchEnrolledCourses } from '../../../global_components/helper_functions/fetchEnrolledCourses';
import { fetchAvailableCourses } from '../../../global_components/helper_functions/fetchAvailableCourses';
import { fetchCoursesHistory } from '../../../global_components/helper_functions/fetchCoursesHistory';
import { fetchTotalActiveUsers } from '../../../global_components/helper_functions/fetchTotalActiveUsers';
import { fetchTotalUpcomingCourses } from '../../../global_components/helper_functions/fetchTotalUpcomingCourses';
import { fetchAllCoursesAdmin } from '../../../global_components/helper_functions/fetchAllCoursesAdmin';
import { fetchCourseParticipants } from '../../../global_components/helper_functions/fetchCourseParticipants';
import { deleteCourseParticipant } from '../../../global_components/helper_functions/deleteCourseParticipant';
import { fetchCourseDetails } from '../../../global_components/helper_functions/fetchCourseDetails';
import { deleteCourse } from '../../../global_components/helper_functions/deleteCourse';

//Components
import StatTile from '../../../global_components/dashboard/StatTile'
import CourseTile from '../../../global_components/dashboard/CourseTile'
import InputField from '../../../global_components/form_components/InputField'
import TextArea from '../../../global_components/form_components/TextArea';
import CourseParticipants from '../../../global_components/dashboard/CourseParticipants';

const CoursesContent = () => {
  //Interactivity handlers
  const [openModals, setOpenModals] = useState([])
  const [enrolledAvailable, setEnrolledAvailable] = useState("enrolledCoursesContainer")
  const [historicCoursesDisplay, setHistoricCoursesDisplay] = useState("")

  useEffect(() => {}, [openModals]);

  useEffect(() => {}, [enrolledAvailable]);

  useEffect(() => {}, [historicCoursesDisplay]);

  const toggleModal = (modalID, senderID) => {
    const modalIndex = openModals.findIndex((modal) => modal.modalID === modalID);

    if (modalIndex > -1) {
      setOpenModals(openModals.filter((modal) => modal.modalID !== modalID));
    } else {
      setOpenModals([...openModals, { modalID, senderID }]);
    }
  }

  const switchEnrolledAvailable = () => {
    if (enrolledAvailable === "enrolledCoursesContainer") {
      setEnrolledAvailable("availableCoursesContainer")
    } else {
      setEnrolledAvailable("enrolledCoursesContainer")
    }
  }

  const toggleHistoricView = () => {
    if (historicCoursesDisplay === "courseHistoryContainer") {
      setHistoricCoursesDisplay("")
      setEnrolledAvailable("enrolledCoursesContainer")
    } else {
      setHistoricCoursesDisplay("courseHistoryContainer")
      setEnrolledAvailable("")
    }
  }

  //API call handlers
  const [isAdmin, setIsAdmin] = useState(false);
  const [coursesAttended, setCoursesAttended] = useState([]);
  const [upcomingCourses, setUpcomingCourses] = useState();
  const [totalCourses, setTotalCourses] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [historicCourses, setHistoricCourses] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    checkUserIsAdmin(setIsAdmin, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchCoursesAttendedNumber(setCoursesAttended, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchUpcomingCoursesNumber(setUpcomingCourses, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchTotalCoursesNumber(setTotalCourses, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchEnrolledCourses(setEnrolledCourses, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchAvailableCourses(setAvailableCourses, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchCoursesHistory(setHistoricCourses, setStatusMessage);
  }, []);

  //Admin API call handlers
  const [totalActiveUsers, setTotalActiveUsers] = useState();
  const [totalUpcomingCourses, setTotalUpcomingCourses] = useState();
  const [courseParticipants, setCourseParticipants] = useState([]);
  const [allCoursesAdmin, setAllCoursesAdmin] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(0);


  useEffect(() => {
    fetchTotalActiveUsers(setTotalActiveUsers, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchTotalUpcomingCourses(setTotalUpcomingCourses, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchAllCoursesAdmin(setAllCoursesAdmin, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchCourseParticipants(setCourseParticipants, setStatusMessage, 0);
  }, [updateTrigger]); 

  const handleDynamicFetchCourseParticipants = (course_ID) => {
    fetchCourseParticipants(setCourseParticipants, setStatusMessage, course_ID);
  }

  const handleDeleteCourseParticipant = (course_ID, user_ID) => {
    deleteCourseParticipant(setStatusMessage, course_ID, user_ID).then(() => {
      fetchCourseParticipants((newParticipants) => {
        setCourseParticipants([...newParticipants]);
      }, setStatusMessage, 0);
    });
  }

  const handleEnrollUserSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    
    const formData = {
      email: e.target.userEmailAddress.value,
      courseID: e.target.courseID.value
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/enrollUser.php?adminRequired=true", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });

      const result = await response.json();

      setStatusMessage(result.message);
    } catch (error) {
        setStatusMessage(error.message);
    } finally {}
  };

  const handleDynamicFetchCourseDetails = (course_ID) => {
    fetchCourseDetails(setCourseDetails, setStatusMessage, course_ID);
  }

  const handleCourseDetailsUpdate = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    
    const formData = {
      courseID: e.target.adminEditCourseID.value,
      title: e.target.adminEditCourseTitle.value,
      date: e.target.adminEditCourseDate.value,
      time: e.target.adminEditCourseTime.value,
      image: e.target.adminEditCourseImage.value,
      maximumEnrolled: e.target.adminEditCourseMaximumEnrolled.value,
      location: e.target.adminEditCourseLocation.value,
      description: e.target.adminEditCourseDescription.value
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/editCourseDetails.php?adminRequired=true", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatusMessage(result.message);
        fetchAllCoursesAdmin(setAllCoursesAdmin, setStatusMessage);
      }
    } catch (error) {
        setStatusMessage(error.message);
    } finally {}
  };

  const handleDynamicCourseDelete = () => {
    deleteCourse(setStatusMessage, openModals.find(modal => modal.modalID === 'adminDeleteCourseModal')?.senderID);
    fetchAllCoursesAdmin(setAllCoursesAdmin, setStatusMessage);
  }

  return (
    <div className='flex flex-col items-center justify-start gap-10 w-full xlg:max-w-2/3'>
      <div className='flex items-center justify-center gap-14 w-full flex-wrap lg:grid lg:grid-cols-3 lg:gap-10 sm:grid-cols-1 sm:gap-6' id='tileContainer'>
        <StatTile 
          tileHeaderText={`${isAdmin ? 'Active users' : 'Courses attended'}`} 
          tileDescription={`${isAdmin ? 'Total number of active users on the platform' : 'Total number of courses attended to date'}`} 
          tileStat={isAdmin ? totalActiveUsers : coursesAttended} 
        />
        <StatTile 
          tileHeaderText='Upcoming courses' 
          tileDescription={`${isAdmin ? 'Number of courses scheduled in total' : 'Number of courses currently enrolled on'}`} 
          tileStat={isAdmin ? totalUpcomingCourses : upcomingCourses} 
        />
        <StatTile 
          tileHeaderText='Total courses' 
          tileDescription='Number of total available courses' 
          tileStat={totalCourses} 
        />
      </div>
      <div className={`${isAdmin ? 'hidden' : 'flex'} w-full items-center justify-between flex-wrap-reverse gap-7`} id='pageHeader'>
        <div className='flex items-center gap-5 w-full sm:w-auto' id='courseToggleSwitchContainer'>
          <h4 className={`${enrolledAvailable.includes('enrolledCoursesContainer') ? 'font-black' : 'font-medium'} text-lg`}>
            Enrolled
          </h4>
          <div className='w-22 h-3 bg-gray-300 rounded-md relative' id='courseToggle'>
            <div
              onClick={() => switchEnrolledAvailable()}
              className={`${enrolledAvailable.includes('enrolledCoursesContainer') ? 'left-0' : enrolledAvailable.includes('availableCoursesContainer') ? 'right-0' : ''} h-7 w-7 rounded-2xl bg-[#06BD60] absolute bottom-0 translate-y-1/3 cursor-pointer`}
              id='courseToggleButton'
            ></div>
          </div>
          <h4 className={`${enrolledAvailable.includes('availableCoursesContainer') ? 'font-black' : 'font-medium'} text-lg`}>
            Available
          </h4>
        </div>

        <div
          onClick={() => toggleHistoricView()}
          className='flex items-center gap-3 cursor-pointer mt-2 sm:mt-0'
          id='coursesHistoryToggle'
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-clock">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <h4 className='text-lg font-medium'>History</h4>
        </div>
      </div>
      <div className={isAdmin ? 'hidden' : 'flex'}>
        <div className={`${enrolledAvailable.includes('enrolledCoursesContainer') ? 'flex' : 'hidden'} flex-col items-start gap-10 pb-10`} id='enrolledCoursesContainer'>
          {enrolledCourses.map((enrolledCourse) => (
            <CourseTile toggleModal={toggleModal} targetModal='courseEnrollSuccessModal' key={enrolledCourse.courseID} courseID={enrolledCourse.courseID} courseTitle={enrolledCourse.courseTitle} courseDescription={enrolledCourse.courseDescription} courseImage={enrolledCourse.courseImage} maximumEnrolled={enrolledCourse.courseMaximumEnrolled} enrolled={enrolledCourse.totalEnrolled} courseDate={enrolledCourse.courseDate} courseTime={enrolledCourse.courseTime} courseLocation={enrolledCourse.courseLocation} overrideButtonStyles={'opacity-50 pointer-events-none'} />
          ))}
        </div>
        <div className={`${enrolledAvailable.includes('availableCoursesContainer') ? 'flex' : 'hidden'} flex-col items-start gap-10 pb-10`} id='availableCoursesContainer'>
          {availableCourses.map((availableCourse) => (
            <CourseTile toggleModal={toggleModal} targetModal='courseEnrollSuccessModal' key={availableCourse.courseID} courseID={availableCourse.courseID} courseTitle={availableCourse.courseTitle} courseDescription={availableCourse.courseDescription} courseImage={availableCourse.courseImage} maximumEnrolled={availableCourse.courseMaximumEnrolled} enrolled={availableCourse.totalEnrolled} courseDate={availableCourse.courseDate} courseTime={availableCourse.courseTime} courseLocation={availableCourse.courseLocation} overrideButtonStyles={availableCourse.totalEnrolled >= availableCourse.courseMaximumEnrolled ? 'opacity-50 pointer-events-none' : ''} />
          ))}
        </div>
        <div className={`${historicCoursesDisplay.includes('courseHistoryContainer') ? 'flex' : 'hidden'} flex-col items-start gap-10 pb-10`} id='courseHistoryContainer'>
          {historicCourses.map((historicCourse) => (
            <CourseTile toggleModal={toggleModal} targetModal='courseEnrollSuccessModal' key={historicCourse.courseID} courseID={historicCourse.courseID} courseTitle={historicCourse.courseTitle} courseDescription={historicCourse.courseDescription} courseImage={historicCourse.courseImage} maximumEnrolled={historicCourse.courseMaximumEnrolled} enrolled={historicCourse.totalEnrolled} courseDate={historicCourse.courseDate} courseTime={historicCourse.courseTime} courseLocation={historicCourse.courseLocation} overrideButtonStyles={'opacity-50 pointer-events-none'} />
          ))}
        </div>
      </div>
      <div className={`${isAdmin ? 'flex' : 'hidden'} flex-col items-start gap-10 pb-10`} id='coursesAdminViewContainer'>
        {allCoursesAdmin.map((allCourseAdmin) => (
          <CourseTile toggleModal={toggleModal} handleDynamicFetchCourseParticipants={handleDynamicFetchCourseParticipants} handleDynamicFetchCourseDetails={handleDynamicFetchCourseDetails} setStatusMessage={setStatusMessage} key={allCourseAdmin.courseID} courseID={allCourseAdmin.courseID} courseTitle={allCourseAdmin.courseTitle} courseDescription={allCourseAdmin.courseDescription} courseImage={allCourseAdmin.courseImage} maximumEnrolled={allCourseAdmin.courseMaximumEnrolled} enrolled={allCourseAdmin.totalEnrolled} courseDate={allCourseAdmin.courseDate} courseTime={allCourseAdmin.courseTime} courseLocation={allCourseAdmin.courseLocation} isAdmin={true} overrideButtonStyles={allCourseAdmin.totalEnrolled >= allCourseAdmin.courseMaximumEnrolled ? 'opacity-50 pointer-events-none' : ''} />
        ))}
      </div>
      <div className={`${openModals.some((modal) => modal.modalID === 'courseEnrollSuccessModal') ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-10 sm:p-20`} id='courseEnrollSuccessModal'>
        <div className='flex flex-col items-center bg-white p-6 sm:p-10 rounded-sm w-full max-w-lg'>
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-check-circle">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <h2 className='text-lg font-medium mt-3 text-left'>Enrolled Successfully</h2>
          <p className='text-base font-regular text-center'>
            You have been enrolled on the course and should receive a confirmation email shortly.
            You will be redirected shortly.
          </p>
        </div>
      </div>
      <div className={`${openModals.some((modal) => modal.modalID === 'adminViewCourseParticipantsModal') ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-10 sm:p-20`} id='adminViewCourseParticipantsModal'>
        <div className='flex flex-col items-start bg-white p-6 sm:p-10 rounded-sm w-full max-w-full sm:max-w-3/4 md:max-w-2/3'>
          <h2 className='text-xl sm:text-2xl font-medium mb-1 text-left'>Course participants</h2>
          <h4 className='text-sm sm:text-base font-normal mb-5'>View and edit enrolled participants on this course</h4>
          <h4 className='text-sm font-normal text-red-500 mb-5'>{statusMessage}</h4>
          <div className='overflow-x-auto w-full max-h-[60vh] overflow-y-auto' id='participantsTable'>
            <table className='min-w-full bg-white mt-5'>
              <thead>
                <tr>
                  <th className='py-2 px-4 text-left text-md font-semibold'>Name</th>
                  <th className='py-2 px-4 text-left text-md font-semibold'>Email Address</th>
                  <th className='py-2 px-4 text-left text-md font-semibold'>Position</th>
                  <th className='py-2 px-4 text-center text-md font-semibold'>Remove</th>
                </tr>
              </thead>
              <CourseParticipants courseParticipants={courseParticipants} handleDeleteCourseParticipant={handleDeleteCourseParticipant} openModals={openModals} />
            </table>
          </div>
          <div className='w-full bg-slate-200 p-3 mt-7 rounded-md'>
            <button className='py-2 px-5 bg-red-500 text-white rounded-sm font-semibold cursor-pointer' onClick={() => toggleModal('adminViewCourseParticipantsModal')}>Dismiss</button>
          </div>
        </div>
      </div>
      <div className={`${openModals.some((modal) => modal.modalID === 'adminAddNewCourseParticipantModal') ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-10 sm:p-20`} id='adminAddNewCourseParticipantModal'>
        <div className='flex flex-col items-start bg-white p-6 sm:p-10 rounded-sm w-full max-w-full sm:max-w-3/4 md:max-w-2/3'>
          <h2 className='text-xl sm:text-2xl font-medium mb-1 text-left'>Enroll a new participant</h2>
          <h4 className='text-sm sm:text-base font-normal mb-5'>Add a new participant to a course. This will send the user an email with the details.</h4>
          <h4 className='text-sm font-normal text-red-500 mb-5'>{statusMessage}</h4>
          <form onSubmit={handleEnrollUserSubmit} className='w-full overflow-auto'>
            <InputField for='userEmailAddress' name='userEmailAddress' labelText='Email address' inputType='email' inputRequired='required' />
            <InputField for='courseID' name='courseID' labelText='' inputType='hidden' value={openModals.find(modal => modal.modalID === 'adminAddNewCourseParticipantModal')?.senderID} inputRequired='' />
            <button className='py-2 px-5 bg-[#06BD60] text-white rounded-sm font-semibold cursor-pointer mt-5' type='submit'>Send</button>
          </form>
          <div className='w-full bg-slate-200 p-3 mt-7 rounded-md'>
            <button className='py-2 px-5 bg-red-500 text-white rounded-sm font-semibold cursor-pointer' onClick={() => toggleModal('adminAddNewCourseParticipantModal')}>Dismiss</button>
          </div>
        </div>
      </div>
      <div className={`${openModals.some((modal) => modal.modalID === 'adminEditCourseDetailsModal') ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-10 sm:p-20`} id='adminEditCourseDetailsModal'>
        <div className='flex flex-col items-start bg-white p-6 sm:p-10 rounded-sm w-full max-w-full sm:max-w-3/4 md:max-w-2/3 overflow-auto max-h-full'>
          <h2 className='text-xl sm:text-2xl font-medium mb-1 text-left'>Edit course details</h2>
          <h4 className='text-sm sm:text-base font-normal mb-5'>Edit this course's details. These will be visible to all participants.</h4>
          <h4 className='text-sm font-normal text-red-500 mb-5'>{statusMessage}</h4>
          <form onSubmit={handleCourseDetailsUpdate} className='w-full max-h-[calc(100vh-10rem)] overflow-auto'>
            <InputField for='adminEditCourseID' name='adminEditCourseID' labelText='Title' inputType='hidden' inputRequired='' value={courseDetails.course_ID} overrideStyles='mb-4' />
            <InputField for='adminEditCourseTitle' name='adminEditCourseTitle' labelText='Title' inputType='text' inputRequired='required' value={courseDetails.title} overrideStyles='mb-4' />
            <InputField for='adminEditCourseDate' name='adminEditCourseDate' labelText='Date' inputType='date' inputRequired='required' value={courseDetails.date} overrideStyles='mb-4' />
            <InputField for='adminEditCourseTime' name='adminEditCourseTime' labelText='Duration' inputType='number' inputRequired='required' value={courseDetails.time} overrideStyles='mb-4' />
            <InputField for='adminEditCourseLocation' name='adminEditCourseLocation' labelText='Location' inputType='text' inputRequired='required' value={courseDetails.location} overrideStyles='mb-4' />
            <InputField for='adminEditCourseImage' name='adminEditCourseImage' labelText='Image link address' inputType='text' inputRequired='required' value={courseDetails.image} overrideStyles='mb-4' />
            <InputField for='adminEditCourseMaximumEnrolled' name='adminEditCourseMaximumEnrolled' labelText='Maximum enrolled' inputType='number' inputRequired='required' value={courseDetails.maximum_Enrolled} overrideStyles='mb-4' />
            <TextArea for='adminEditCourseDescription' name='adminEditCourseDescription' labelText='Description' inputRequired='required' value={courseDetails.description} overrideStyles='mb-4' />
            <button className='py-2 px-5 bg-[#06BD60] text-white rounded-sm font-semibold cursor-pointer mt-5' type='submit'>Update</button>
          </form>
          <div className='w-full bg-slate-200 p-3 mt-7 rounded-md'>
            <button className='py-2 px-5 bg-red-500 text-white rounded-sm font-semibold cursor-pointer' onClick={() => toggleModal('adminEditCourseDetailsModal')}>Dismiss</button>
          </div>
        </div>
      </div>
      <div className={`${openModals.some((modal) => modal.modalID === 'adminDeleteCourseModal') ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-10 sm:p-20`} id='adminDeleteCourseModal'>
        <div className='flex flex-col items-start bg-white p-6 sm:p-10 rounded-sm w-full max-w-full sm:max-w-3/4 md:max-w-2/3'>
          <h2 className='text-xl sm:text-2xl font-medium mb-1 text-left'>Are you sure?</h2>
          <h4 className='text-sm sm:text-base font-normal mb-5'>This will remove the course from the database, and course participants will not be able to see it again.</h4>
          <h4 className='text-sm font-normal text-red-500 mb-5'>{statusMessage}</h4>
          <button className='py-2 px-5 bg-[#06BD60] text-white rounded-sm font-semibold cursor-pointer mt-5' onClick={() => handleDynamicCourseDelete()}>Do it!</button>
          <div className='w-full bg-slate-200 p-3 mt-7 rounded-md'>
            <button className='py-2 px-5 bg-red-500 text-white rounded-sm font-semibold cursor-pointer' onClick={() => toggleModal('adminDeleteCourseModal')}>Dismiss</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoursesContent